module.exports = __webpack_public_path__ + "img/logo.b56595b8.png";